import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const sendMessage = (message) =>
  http.post('/whatsapp/messages', message);

export const getMessagesFromJob = (protocol) =>
  http.get(`/job/${protocol}/messages`);

export const getMessagesToday = (contactIdentifier) => {
  return http.get('/whatsapp/messages/history/today', {
    params: {
      identifier: contactIdentifier,
    },
  });
};

export const activeSessionStatus = (protocolList) => {
  return http
    .post('/job/whatsapp/check-active-sessions', protocolList)
    .then(handleResponse);
};

export const getMessageById = (id) => {
  return http.get(`/whatsapp/messages/${id}`).then(handleResponse);
};
